<template>
    <div class="page-container">
        <div class="fixed-header">
            <!-- <Content /> -->
            <div class="content-top">
                <div class="const-a">
                    <div class="content-top-left">
                        <img src="../assets/images/ap-1.png" alt="" @click="goToHome">
                    </div>
                    <!-- 顶部标题 -->
                    <div class="content-top-right">
                        <div class="text-a knowledge-points-title" :class="{ active: currentSubject === 'calculus' }"
                            @click="goToCalculusBC">
                            Calculus BC</div>
                        <div class="text-a" :class="{ active: currentSubject === 'microeconomics' }"
                            @click="goToMicroeconomics">Microeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'macroeconomics' }"
                            @click="goToMacroeconomics">Macroeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'physics' }" @click="goToPhysics1">
                            Physics1</div>
                        <div class="text-a" :class="{ active: currentSubject === 'biology' }" @click="goToBiology">
                            Biology</div>
                        <div class="text-a" :class="{ active: currentSubject === 'csp' }" @click="goToCSP">CSP</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrollable-content">
            <div class="nav-container">
                <div class="nav-aboutus">
                    <div class="v-line-content">
                        <div class="v-line">
                            ABOUT US
                        </div>
                        <div class="v-line-bottom">
                            We're a friendly and student-focused learning platform designed especially for students
                            preparing&nbsp;for
                            AP <br>
                            exams. We offer clear and reliable AP question banks, step-by-step explanations, and
                            easy-to-understand <br>
                            study notes to help you feel confident and well-prepared. No matter where you're from or
                            which&nbsp;AP&nbsp;subject <br>
                            
                            you're studying, we're here to make your learning journey easier, smoother, and&nbsp;more&nbsp;successful.Let'saim <br>
                           
                            for an APsolute 5 together!
                        </div>

                        <div class="picture1">
                            <img src="../assets/images/yy.png" alt="">
                        </div>
                    </div>


                </div>
            </div>
        </div>
        <!-- 移除了 fixed-footer 包裹元素 -->
        <Concat />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Concat from '../components/Concat.vue'


const router = useRouter()



// 页面导航函数
const goToHome = () => {
    router.push('/')
}

const goToMicroeconomics = () => {
    router.push('/calculusbc')
}

const goToBiology = () => {
    router.push('/calculusbc')
}

const goToPhysics1 = () => {
    router.push('/calculusbc')
}

const goToCSP = () => {
    router.push('/calculusbc')
}

const goToMacroeconomics = () => {
    router.push('/calculusbc')
}

const goToCalculusBC = () => {
    router.push('/calculusbc')
}












</script>

<style scoped>
.v-line-bottom {
    width: 1200px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
    text-align: left;
    line-height: 46px;
    white-space: pre-line;
    white-space: nowrap;
}



.knowledge-points-title {
    white-space: nowrap;
}
/* .fixed-header {
    flex-shrink: 0;
} */

.content-top {
    width: 1440px;
    height: 100px;
    width: 100vw;
    background-color: black;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.const-a {
    width: 1200px;
    height: 100px;
    display: flex;
    align-items: center;
}

.content-top-left {
    width: 202px;
    height: 44px;
    margin-right: 108px;
}

.content-top-left img {
    width: 202px;
    height: 44px;
    cursor: pointer;
}

.content-top-right {
    width: 890px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.text-a {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    margin-right: 39px;
    cursor: pointer;
}

.text-a.active {
    text-decoration: underline;
}
/* ---------------- */
.page-container {
    display: flex;
    flex-direction: column;
    /* height: 100vh; */
}

.fixed-header {
    flex-shrink: 0;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    /* max-height: 1732px; */
}

/* .fixed-footer {
    flex-shrink: 0;
} */

@import '../pages/index-aboutus.css'
</style>